import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Response_HPLocation } from '../../../../../constants/APIs';

export default class HolidayParkLocation extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Response_HPLocation} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
